import "./certificates-page.less"
import Layout from "../layouts/layout"
import { useMessages } from "../language/language"
import { ErrorAlert } from "../components/alert"
import { Link } from "react-router-dom"
import PercentageList from "../components/percentage-list"
import PercentageListItem from "../components/percentage-list-item"
import { serverGetCertificates } from "utils/server"
import Loading from "../components/loading"
import { useEffect, useState } from "react"
import { usePlayState } from "play/hooks/use-play-state"
import { PlaySessionCertificate } from "models/tables"

export default function CertificatesPage() {
  const msg = useMessages()
  const { serverError, isPreview } = usePlayState()
  const [state, setState] = useState({
    isLoading: false as boolean,
    certificates: [] as PlaySessionCertificate[],
  })
  const { certificates, isLoading } = state

  useEffect(() => {
    document.title = msg.pageTitle(msg.pageTitleCertificates)

    if (!isPreview) {
      setState((prev) => ({ ...prev, isLoading: true }))

      serverGetCertificates()
        .then((certificates) => {
          setState({
            certificates,
            isLoading: false,
          })
        })
        .catch((e) => {
          console.warn("failed to load certs", e)
          setState((prev) => ({
            ...prev,
            isLoading: false,
          }))
        })
    }
  }, [])

  return (
    <Layout
      timerEnabled={false}
      screenCounterEnabled={false}
      scrollingEnabled={true}
      nextEnabled={false}
      prevEnabled={false}
      pointsEnabled={false}
      logoIsLink={true}
    >
      <div className="certificates-page">
        <ErrorAlert error={msg.serverErrorToString(serverError)} />
        <p className="breadcrumb">
          <Link to="/">{msg.back}</Link>
        </p>
        <h1 className="dot">{msg.pageTitleCertificates}</h1>
        <Loading isLoading={isLoading} className="loading">
          <PercentageList>
            {certificates.map((cert) => {
              return (
                <PercentageListItem
                  key={`r_${cert.reportId}_s_${cert.userId}`}
                  title={cert.title}
                  successRate={cert.studentSuccessRate}
                  href={cert.downloadUrl}
                  download={"certificate.pdf"}
                />
              )
            })}
            {certificates.length === 0 && msg.certificatesNone}
          </PercentageList>
        </Loading>
      </div>
    </Layout>
  )
}
